import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import OptionButton from '../../components/onboarding/OptionButton';
import { useOnboarding } from '../../contexts/OnboardingContext';

const OnboardingStep6 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { responses, updateResponses, markStepCompleted } = useOnboarding();
  const [selected, setSelected] = useState<string[]>(responses.transportation || []);
  const progress = (6 / 14) * 100;

  const options = [
    { value: 'mobil', label: t('onboarding.step6.options.mobil'), emoji: '🚙' },
    { value: 'motor', label: t('onboarding.step6.options.motor'), emoji: '🏍️' },
    { value: 'sepeda', label: t('onboarding.step6.options.sepeda'), emoji: '🚲' },
    { value: 'kendaraan_umum', label: t('onboarding.step6.options.kendaraan_umum'), subtitle: t('onboarding.step6.options.kendaraan_umum_sub'), emoji: '🚎' },
    { value: 'ride_hailing', label: t('onboarding.step6.options.ride_hailing'), subtitle: t('onboarding.step6.options.ride_hailing_sub'), emoji: '🚕' }
  ];

  const toggleOption = (value: string) => {
    setSelected(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };

  const handleNext = () => {
    updateResponses('transportation', selected);
    markStepCompleted(6);
    navigate('/onboarding/step-7');
  };

  const handleSkip = () => {
    setSelected([]);
    updateResponses('transportation', []);
    navigate('/onboarding/step-7');
  };

  return (
    <OnboardingLayout progress={progress}>
      <div className="bg-white border-4 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>
        <div className="mb-6">
          <h2 className="text-base text-center text-[#077f5d] mb-4 uppercase" style={{ fontFamily: "'Press Start 2P', monospace" }}>
            {t('onboarding.step6.title')}
          </h2>
        </div>

        <div className="space-y-3 mb-6">
          {options.map(option => (
            <OptionButton
              key={option.value}
              label={option.label}
              emoji={option.emoji}
              subtitle={option.subtitle}
              selected={selected.includes(option.value)}
              onClick={() => toggleOption(option.value)}
            />
          ))}
        </div>

        {/* Skip option as clickable text */}
        <div className="text-center mb-6">
          <button
            type="button"
            onClick={handleSkip}
            className="text-[#1a1a1a] font-bold opacity-70 hover:opacity-100 hover:underline transition-all duration-150"
            style={{
              fontSize: '14px',
            }}
          >
            {t('onboarding.step6.skip')}
          </button>
        </div>

        <button
          type="button"
          onClick={handleNext}
          disabled={selected.length === 0}
          className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase   hover:-translate-y-[2px] active:translate-y-[2px] active:shadow-none transition-all duration-75 disabled:opacity-50 disabled:cursor-not-allowed disabled:translate-y-0"
          style={{
            fontFamily: "'Press Start 2P', monospace",
            fontSize: '12px',
            boxShadow: '6px 6px 0 #077f5d'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(-2px, -2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(0, 0)';
          }}
        >
          {t('onboarding.step6.next')}
        </button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingStep6;
